<template>
  <div class="lead-timeline-menu">
    <div class="lead-timeline-menu-list">
						<span class="lead-timeline-menu-list-togglebtn" id="filterToggle">
							<svg id="filterArrowR" viewBox="0 0 612 612" width="16" height="16">
								<g>
									<g>
										<path class="st0" d="M587.6,186.9c-32.3-75.2-87.1-129.9-163-162.3C386.7,8.4,347,0.2,305.5,0.2s-80.9,8.2-118.8,24.4
			C111.5,56.9,56.4,111.5,24.1,186.9C7.9,224.6,0,264.2,0,305.7c0,41.5,7.9,81.4,24.1,119.1c32.3,75.3,87.4,130.3,162.6,162.6
			c37.9,16.2,77.3,24.4,118.8,24.4s81.2-8.3,119.1-24.4c75.9-32.4,130.7-87.4,163-162.6c16.2-37.9,24.4-77.6,24.4-119.1
			C612,264.2,603.8,224.8,587.6,186.9z M538.7,440.9c-24,41.2-56.9,73.9-98.4,98c-41.2,24-86.3,36.1-134.8,36.1
			c-36.5,0-71.3-7-104.4-21.4c-33.1-14.4-61.7-33.3-85.7-57.2c-23.9-23.9-43-52.8-57.2-86C44,377.3,37.1,342.1,37.1,305.7
			c0-48.5,11.9-93.4,35.8-134.5c24-41.2,56.9-73.9,98-98C212.1,49,257,37,305.5,37s93.6,12.1,134.8,36.1
			c41.5,24.2,74.3,56.9,98.4,98c24.1,41.2,36.1,86,36.1,134.5C574.9,354.2,562.9,399.4,538.7,440.9z"></path>
										<path class="st0" d="M270,129c-7.6-7.8-19.4-7.4-26.1-0.7c-7.7,7.7-7.3,19-0.7,25.8l149.6,153.6L243.3,457.2
			c-7.2,7.2-6.7,19.1,0,25.8c3.7,3.7,8.4,5.7,13.7,5.7c5,0,9.4-2,13-5.7l162.3-161.6c7.2-7.2,6.6-19.3,0-26.1L270,129z"></path>
									</g>
								</g>
							</svg>

						</span>
      <ul class="timeline-menu-list">
        <li>
          <a class="timeline-menu-list-active" href="#" data-type="all">All</a>
        </li>
        <li>
          <a href="#" data-type="comments">Comments</a>
          <span class="comment-counter timeline-counter">29</span>
        </li>
        <li>
          <a href="#" data-type="updates">Updates</a>
          <span class="updates-counter timeline-counter">3</span>
        </li>
        <li>
          <a href="#" data-type="calls">Calls</a>
          <span class="calls-counter timeline-counter">0</span>
        </li>
        <li>
          <a href="#" data-type="balance">Balance</a>
          <span class="balance-counter timeline-counter">0</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuTimeLine"
}
</script>

<style scoped>

</style>
